@if (selectedRows$ | async; as selectedRows) {
    <app-manual-flow-footer
        info="{{ 'FOOTER.ROW_SELECTION.NUMBER_OF_ROW_SELECTED' | translate: { count: selectedRows.length } }}"
        (cancel)="cancelSelection()"
        (next)="onSelectionComplete()"
        [nextEnabled]="selectedRows.length > 0"
        [cancelEnabled]="selectedRows.length > 0"
        data-test="row-multi-selection-bar"
    />
}
